import { Fragment, useMemo } from 'react';
import { noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { BuilderIcon, useManageDashboardActions } from '@diana/core';
import { Button } from '@mui/material';
import { REPORTING_PAGE_NS } from './i18n';

export const BuilderButton = (props: { reportId: string }) => {
  const { reportId } = props;
  const { t } = useTranslation(REPORTING_PAGE_NS);

  const { actions = [] } = useManageDashboardActions({ id: reportId, setProcessing: noop });
  const builderAction = useMemo(() => {
    return actions.find((action) => action.testId === 'edit-performance-dashboard-action') ?? null;
  }, [actions]);

  if (!builderAction || builderAction.disabled) return <Fragment />;

  return (
    <Button
      variant="contained"
      color="secondary"
      size="small"
      data-testid="PerformanceReportBuilderButton"
      sx={({ spacing }) => ({ py: 0, minHeight: spacing(4) })}
      startIcon={<BuilderIcon fontSize="small" />}
      onClick={() => {
        if (builderAction.onClick) {
          builderAction.onClick({ close: noop });
        }
      }}
    >
      {t('buttons.builder')}
    </Button>
  );
};
